import { useQuery } from "@tanstack/react-query";
import { useState } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import videoApi from "../../api/videoApi";
import { timeAgo } from "../../common";
import ButtonIcon from "../../components/ButtonIcon";
import Layout from "../../components/Layout";
import Title from "../../components/Title";
import UploadVideoPopup from "../../components/UploadVideoPopup";
import VideoCard from "../../components/VideoCard";
import WarningDeleteVideoPopup from "../../components/WarningDeleteVideoPopup";
import { RootState } from "../../store";

function Lession() {

    const [activeTab, setActiveTab] = useState<number>(1);
    const [showPopup, setShowPopup] = useState(false);

    const { user } = useSelector((state: RootState) => state.auth);
    const isStaff = user?.roles.includes("student_management") || user?.roles.includes("teacher") || user?.roles.includes("branch_manager") || user?.roles.includes("staff") || user?.roles.includes("admin");
    const tabs = [{ id: 1, name: "Toán" }, { id: 2, name: "Tiếng Việt" }, { id: 3, name: "Tiếng Anh" }, { id: 4, name: "Khoa Học Tự Nhiên" }];

    const handleChangeTab = (id: number) => {
        setActiveTab(id);
    };

    const handleUpload = () => {
        setShowPopup(true);
    }

    const handleCloseUploadPopup = () => {
        setShowPopup(false);
    };

    const { data: videos = [], refetch } = useQuery({
        queryKey: ["videos", activeTab],
        queryFn: async () => {
            const res = await videoApi.getVideosBySubject(activeTab);
            const sorted = res.data.data.sort((a: any, b: any) => {
                return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
            });
            return sorted.map((item: any) => ({
                id: item.id,
                title: item.name,
                url: item.url,
                timeAgo: timeAgo(item.createdAt)
            }));
        },
    });

    const handleSuccess = () => {
        refetch();
        toast.success("Upload video thành công");
    }

    const [show, setShow] = useState<boolean>(false);
    const [videoToDelete, setVideoToDelete] = useState<number | null>(null);

    const handleCloseDeletePopup = () => {
        setShow(false);
        setVideoToDelete(null);
    };

    // const handleGetComment = (payload: { comment: string; file: File | null }) => {
    //     console.log("Comment received in Lession page:", payload);
    // }

    return (
        <Layout>
            {show && (<WarningDeleteVideoPopup
                videoId={videoToDelete}
                onClose={handleCloseDeletePopup}
                onCancel={handleCloseDeletePopup}
                onSuccess={() => {
                    toast.success("Xóa video thành công!");
                    refetch();
                }}
            />)}
            {showPopup && <UploadVideoPopup onClose={handleCloseUploadPopup} onSuccess={handleSuccess} />} {/* Hiển thị popup khi success */}
            <section className="w-full h-fit py-[60px] px-[20px] lg:px-[50px] text-center bg-[#f9f9f9]">
                <Title title="Bài Giảng Video" subTitle="Học tập trực quan với các bài giảng video chất lượng cao" />
                <div className="mx-auto mt-[40px] w-fit flex flex-wrap justify-center items-center gap-[20px]">
                    {tabs.map((tab) => (
                        <span
                            key={tab.id}
                            onClick={() => handleChangeTab(tab.id)}
                            className={`py-[10px] px-[20px] rounded-[30px] cursor-pointer transition-all duration-300
                                                ${activeTab === tab.id
                                    ? "bg-secondary text-white shadow-md"
                                    : "bg-white text-bold border border-[#e0e0e0] hover:bg-secondary hover:text-white"
                                }`}
                        >
                            {tab.name}
                        </span>
                    ))}
                </div>
                {isStaff && <div className="my-[20px]">
                    <ButtonIcon label="Upload video" onClick={handleUpload} styleButton="ml-auto" />
                </div>}
                <div className={`flex flex-col lg:flex-row mt-[40px] lg:justify-start flex-wrap gap-y-[30px] gap-x-[30px] pt-[10px] max-h-[640px] custom-scroll ${videos.length > 6 ? "overflow-y-scroll" : ""}`}>
                    {videos.length === 0 ? (
                        <p className="text-gray-500 text-center mx-auto">Chưa có bài giảng cho môn học này.</p>
                    ) : (videos.map((video: any) => {
                        return (
                            <div className="lg:w-[31%] w-full" key={video.id}>
                                <VideoCard video={video} onSuccess={handleSuccess} onDelete={(id) => {
                                    setVideoToDelete(id);
                                    setShow(true);
                                }} />
                            </div>
                        )
                    }))}
                </div>
                {/* <Comment onComment={handleGetComment} /> */}
            </section>
        </Layout>
    );
}

export default Lession;